import type { StaticImageData } from 'next/image'
import type { ReactElement } from 'react'
import type { ChartDataRow } from '../../../types'
import { StyledAssetCellImage } from '../styled'
import type { ChartCardTableBodyCellContext } from '../tanstack'

interface TableBodyAssetCellProps<DataKey extends string, DataRow extends ChartDataRow<DataKey>> {
  context: ChartCardTableBodyCellContext<DataKey, DataRow>
  asset: string | StaticImageData
  assetName: string
}

const TableBodyAssetCell = <DataKey extends string, DataRow extends ChartDataRow<DataKey>>({
  context: _context,
  asset,
  assetName
}: TableBodyAssetCellProps<DataKey, DataRow>): ReactElement => {
  return <StyledAssetCellImage src={asset} alt={assetName} />
}

export default TableBodyAssetCell
